export const jsonLdData = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [{
    '@type': 'Question',
    name: 'Are there actual human Stylists?',
    acceptedAnswer: {
      '@type': 'Answer',
      text: "Yes—Stitch Fix works with thousands of trained men's Stylists across the U.S. who are fashion experts focused on learning your style and needs."
    }
  }, {
    '@type': 'Question',
    name: 'Styling sounds expensive—what are pricing and fees like?',
    acceptedAnswer: {
      '@type': 'Answer',
      text: 'You set your own price range by item type. Styling fees are $20 per Fix, credited toward kept items. Items start at $28. Shipping, returns, and exchanges are always free.'
    }
  }, {
    '@type': 'Question',
    name: 'Is this a subscription?',
    acceptedAnswer: {
      '@type': 'Answer',
      text: 'No subscription is required. You can receive Fixes automatically or on demand—whatever fits your lifestyle best.'
    }
  }, {
    '@type': 'Question',
    name: 'How do you nail my fit?',
    acceptedAnswer: {
      '@type': 'Answer',
      text: 'Fit is refined through your style quiz, size preferences, brand options, feedback from prior Fixes, and notes you leave for your Stylist.'
    }
  }, {
    '@type': 'Question',
    name: 'How does my Stylist know what to send me?',
    acceptedAnswer: {
      '@type': 'Answer',
      text: 'Your style quiz, feedback, profile history, and notes all help Stylists curate personalized selections tailored to your style.'
    }
  }, {
    '@type': 'Question',
    name: 'How do I communicate with my Stylist?',
    acceptedAnswer: {
      '@type': 'Answer',
      text: 'Leave a note during Fix scheduling via the website or app. You can edit the note until styling begins.'
    }
  }, {
    '@type': 'Question',
    name: 'What range of sizes do you carry?',
    acceptedAnswer: {
      '@type': 'Answer',
      text: 'Men: XS–3XL including Big & Tall. Women: XS–3X including petite, plus & maternity. Kids: 2T–18.'
    }
  }, {
    '@type': 'Question',
    name: "Do you have kids' clothing?",
    acceptedAnswer: {
      '@type': 'Answer',
      text: 'Yes—kids’ sizes range from 2T to 18, with prices starting at just $12.'
    }
  }, {
    '@type': 'Question',
    name: 'What brands do you carry?',
    acceptedAnswer: {
      '@type': 'Answer',
      text: 'Over 1,000 brands including Madewell, The North Face, Adidas, Free People, and exclusive Stitch Fix labels.'
    }
  }, {
    '@type': 'Question',
    name: 'Can I browse and purchase pieces on my own?',
    acceptedAnswer: {
      '@type': 'Answer',
      text: 'Yes—once you receive a Fix, you unlock Freestyle: a personalized shop to browse and purchase curated items.'
    }
  }, {
    '@type': 'Question',
    name: 'How often will I receive a Fix?',
    acceptedAnswer: {
      '@type': 'Answer',
      text: 'You choose the frequency: every 2–3 weeks, monthly, every other month, or quarterly. You can also order on demand.'
    }
  }, {
    '@type': 'Question',
    name: 'How can I shop for my whole family?',
    acceptedAnswer: {
      '@type': 'Answer',
      text: 'Create a family account to manage Fixes for one adult and up to four kids—all sharing the same shipping and billing info.'
    }
  }, {
    '@type': 'Question',
    name: 'Can I have my partner on my account?',
    acceptedAnswer: {
      '@type': 'Answer',
      text: 'Each adult needs their own account, but if your partner signs up via referral, you both get credit.'
    }
  }, {
    '@type': 'Question',
    name: 'How do I use Buy Now Pay Later options?',
    acceptedAnswer: {
      '@type': 'Answer',
      text: 'Buy Now Pay Later options like Affirm, Klarna, and Afterpay are available for eligible Fix and Freestyle purchases at checkout.'
    }
  }]
};